import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { ShieldWarning } from '@phosphor-icons/react';

export const RoleGuard = ({ roles, children, fallback = null }) => {
  const { hasRole } = useAuth();

  if (!hasRole(roles)) {
    if (fallback) return fallback;
    return (
      <Alert variant="destructive" className="m-4">
        <ShieldWarning className="h-4 w-4" />
        <AlertDescription>
          You don't have permission to access this resource.
        </AlertDescription>
      </Alert>
    );
  }

  return <>{children}</>;
};